// eslint-disable-next-line import/prefer-default-export
export const updateDesignId = value => ({
    type: 'DESIGN_SUBMITTED',
    value
});

export const resetCustomCakeTopperData = () => ({
    type: 'RESET',
});
